module.exports = __webpack_public_path__ + "static/media/Sibenicni_vrch.6e650524.md";